<template>
  <div
    ref="container"
    :index="index"
    :tabindex="index"
    :id="postData.key"
    v-observe-visibility="{
      callback: visibilityPostChanged,
      intersection: {
        threshold: 0.2
      }
    }"
  >
    <div class="publication">
      {{ postData.key }}
      <media
        ref="media"
        :type="postData.media.type"
        :mediaSource="postData.media"
        :size="totalWidth"
        :muted="muted"
        :index="index"
        :keyPost="postData.key"
        :isVisible="isLoadableInRange"
      />
      <links :links="postData.links" />
      <div class="publicationRow">
        <author
          :keyPost="postData.key"
          :author="postData.author"
          :actionsShare="postData.share"
          :actionsData="postData"
          :isSingle="isSingle"
        />
        <tags :tagList="postData.tags" :isSingle="isSingle" />
        <description :published_at="postPublishedAt" :description="postText" />
        <receiver :receiver="postData.receiver" />
      </div>
    </div>
  </div>
</template>

<script>
import Media from '@/components/media'
import Links from './links'
import Author from './author'
import Tags from './tags'
import Description from './description'
import Receiver from './receiver'
// import Format from '@/helper/Format.js'
import { mapGetters, mapActions } from 'vuex'
import { secParseJSON } from '@/helper/helper'
import { RegisterEvent } from '@/analytics'

export default {
  name: 'item-component',
  components: {
    Media,
    Links,
    Author,
    Tags,
    Description,
    Receiver
  },
  props: {
    totalWidth: Number,
    index: Number,
    source: {
      type: Object,
      default () {
        return {}
      }
    },
    showLast: Boolean,
    isSingle: {
      type: Boolean
    }
  },
  data () {
    return {
      playing: false,
      muted: false,
      timeFirst: 0,
      timeFinish: 0,
      minHeigth: 350
    }
  },
  computed: {
    ...mapGetters([
      'getVisibleIndexMin',
      'getVisibleIndexMax',
      'getFontSizeDeviceInfo'
    ]),
    postData () {
      return this.source
    },
    postPublishedAt () {
      return this.postData.published_at
    },
    postText () {
      return secParseJSON(this.postData.description)
    },
    fontSizeText () {
      return this.getFontSizeDeviceInfo
    },
    isLoadableInRange () {
      return (
        !(this.index < this.getVisibleIndexMin - 2) &&
        !(this.index > this.getVisibleIndexMax + 2)
      )
    }
  },
  methods: {
    ...mapActions({
      insertVisible: 'INSERT_VISIBLE',
      removeVisible: 'REMOVE_VISIBLE',
      resetVisible: 'RESET_VISIBLE_POSITIONS'
    }),
    visibilityPostChanged (isVisible) {
      if (navigator.onLine) {
        if (isVisible) {
          this.timeFirst = new Date().getTime()
          this.insertVisible(this.index)
        } else {
          this.removeVisible(this.index)
          if (this.timeFirst > 0) {
            this.timeFinish = new Date().getTime()
            const duration = this.timeFinish - this.timeFirst
            this.timeFirst = 0
            this.timeFinish = 0
            if (parseInt(duration) >= 3000) {
              RegisterEvent('chi_post_focused', {
                target_id: this.source.key,
                target_type: 'post_id',
                duration: parseInt(duration / 1000)
              })
            }
          }
        }
      } else {
        this.resetVisible()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/publication/index.vue